module.exports = __webpack_public_path__ + "img/galeria-especie-prioritaria-6.d3bc808d.jpg";